module.exports = __webpack_public_path__ + "static/media/analiseDiscurso.59dfd038.md";